module.exports = __webpack_public_path__ + "static/media/19ESCAP3.f86e71a5.jpg";